import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

import NewTariffCard from '~/src/components/NewTariffCard';
import { alignHeightsCard } from '~/src/components/TariffCard/helpers';
import ChannelListPopup from '~/src/components/Bundles/ChannelListPopup';
import PopupOnlineRequest from '~/src/components/Popups/PopupRequest/PopupOnlineRequest';
import { CustomArrows, breakpoints, SlideWrapper } from '~/src/components/Internet/TariffList';
import { CustomCarousel } from '~/src/components/Internet/TariffList/styled';

import { formattingBundleForCard } from '~/src/helpers/formatter';
import { EVENTS } from '~/src/constants/analytics';
import {
    clearSearchChannels,
    clearChannelThemeSelection,
    clearChannelsBundleId,
    filterChannelsByTheme,
    setFilterForChannelsAction,
    setSelectedTariffIdAction,
} from '~/src/store/actions/bundles';

class TariffList extends Component {
    tariffCards = [];

    constructor(props) {
        super(props);

        this.state = {
            activeSlide: 0,
            channelPopupOpen: false,
            requestPopupOpen: {
                tariff: {},
                isOpen: false,
            },
            channelPopupLabel: null,
            windowWidth: 1990,
        };

        if (process.browser) {
            this.state.windowWidth = window.innerWidth;
        }

        this.list = React.createRef();
    }

    openModal = (label) => {
        this.props.changeFiltersTheme('1');
        this.setState({
            channelPopupOpen: true,
            channelPopupLabel: label,
        });
    };

    onClosePopup = () => {
        this.setState({
            channelPopupOpen: false,
        });
        this.props.changeFiltersTheme('1');
        this.props.clearChannelThemeSelection();
        this.props.clearSearchChannels();
        this.props.clearChannelsBundleId();
        this.props.setFilterForChannels({
            value: '1',
            label: 'Общедоступные',
        });
    };

    onCloseFullBuyRequestPopup = () => {
        this.setState({
            ...this.state,
            requestPopupOpen: {
                ...this.state.requestPopupOpen,
                isOpen: false,
            },
        });
    };

    onClickOnlineHandler = tariff => {
        this.setState({
            ...this.state,
            requestPopupOpen: {
                tariff: tariff,
                isOpen: true,
            },
        });
        dataLayerPush({ event: EVENTS.UAevent, category: 'fullbuy', action: 'pop_up', label: null });
    };

    render() {
        const {
            tariffs,
            cityDomain,
            isAuth,
            city,
        } = this.props;
        const { channelPopupOpen, channelPopupLabel, requestPopupOpen } = this.state;

        tariffs.sort((bundle1, bundle2) => {
            const weight1 = bundle1?.description?.weight ?? null;
            const weight2 = bundle2?.description?.weight ?? null;

            if (weight1 === weight2) {
                return bundle1?.speed_int - bundle2?.speed_int;
            }

            if (weight1 === null) {
                return 1;
            }

            if (weight2 === null) {
                return -1;
            }

            return weight1 - weight2;
        });

        const tariffList = tariffs.map(tariffItem => {
            const tariff = formattingBundleForCard(tariffItem, isAuth);

            return (
                <SlideWrapper
                    key={tariffItem.id}
                >
                    <NewTariffCard
                        cityDomain={cityDomain}
                        tariff={tariff}
                    />
                </SlideWrapper>
            );
        });

        return (
            <GridContainer>
                <CustomCarousel
                    data-test='carousel-container'
                    visibleCardWidth={1920}
                    responsive={breakpoints}
                    showArrows={true}
                    showDots={false}
                    arrows={CustomArrows}
                    showTransparent={true}
                    scrollByShow={true}
                    hideArrow={true}
                >
                    {tariffList}
                </CustomCarousel>
                <ChannelListPopup
                    isOpen={channelPopupOpen}
                    onClose={this.onClosePopup}
                    tariffName={channelPopupLabel}
                />
                <PopupOnlineRequest
                    isOpen={requestPopupOpen.isOpen}
                    texts={{ title: 'Как вы хотите подключить услугу?', subtitle: '' }}
                    city={city}
                    onClose={this.onCloseFullBuyRequestPopup}
                    tariff={requestPopupOpen.tariff}
                />
            </GridContainer>
        );
    }

    onClickChannels = tariff => {
        const selectedTariffId = String(tariff.salePackageId);

        this.openModal(tariff.title);
        this.props.setSelectedTariffId(selectedTariffId);

        dataLayerPush({
            event: EVENTS.UAevent,
            category: 'Click Bundles on the channel',
            action: 'view channels',
            label: null,
        });
    };

    componentDidMount() {
        alignHeightsCard();

        if (process.browser) {
            const alignAfterLoad = () => {
                alignHeightsCard();
                window.addEventListener('resize', () => {
                    this.setState({ windowWidth: window.innerWidth });
                });
                window.removeEventListener('load', alignAfterLoad);
            };
            window.addEventListener('load', alignAfterLoad);
        }
    }

    componentDidUpdate() {
        alignHeightsCard();
    }

}

TariffList.propTypes = {
    tariffs: PropTypes.array,
    cityDomain: PropTypes.string,
    city: PropTypes.object,
    onClickButtonHandlerForCard: PropTypes.func,
    textButtonForCard: PropTypes.string,
    hideDescription: PropTypes.bool, // не показывать описание тарифа в карточке
    enableDetalization: PropTypes.bool, // не уводить с карточки на детализацию тарифа
    hideAdditionalProducts: PropTypes.bool, // не показывать доп. оборудование
};

TariffList.defaultProps = {
    hideDescription: false,
    enableDetalization: true,
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain,
    isAuth: state.auth.isAuth,
    city: state.city.currentCity,
    themeId: state.bundles.themeId,
});

const mapDispatchToProps = (dispatch) => ({
    clearSearchChannels: () => dispatch(clearSearchChannels()),
    clearChannelThemeSelection: () => dispatch(clearChannelThemeSelection()),
    clearChannelsBundleId: () => dispatch(clearChannelsBundleId()),
    changeFiltersTheme: themeId => dispatch(filterChannelsByTheme(themeId)),
    setFilterForChannels: selectedFilter => dispatch(setFilterForChannelsAction(selectedFilter)),
    setSelectedTariffId: selectedTariffId => dispatch(setSelectedTariffIdAction(selectedTariffId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TariffList);
